import aboutModule from "./aboutModule"
import aboutView from "./aboutView.html"

aboutModule.directive("nlgAbout", [()=>{
    return {
        restrict: "E",
        template: aboutView
    }
}])